import React from "react";
import { Collapse } from "reactstrap";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

// Shared by "Show Sample Prompts", "Sample Messages" and "Let AI write it for
// you" — the WHOLE row toggles, so the hit target matches the card.
const BwaiCollapseSection = ({ icon, label, isOpen, onToggle, children }) => {
  return (
    <div>
      <div
        className="bwai_prompts_head d-flex justify-content-between align-items-center"
        role="button"
        tabIndex={0}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            // Space would otherwise scroll the modal body as well as toggling.
            e.preventDefault();
            onToggle();
          }
        }}
      >
        <span className="bwai_prompts_head_label">
          {icon}
          {label}
        </span>

        <span className="bwai_prompts_head_caret">
          {isOpen ? <FiChevronUp /> : <FiChevronDown />}
        </span>
      </div>

      <Collapse isOpen={isOpen}>{children}</Collapse>
    </div>
  );
};

export default BwaiCollapseSection;
